"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcSubSalesPersonsField = void 0;
var react_1 = __importDefault(require("react"));
var ac_ui_1 = require("@aperza/ac-ui");
var AcSalesPersonField_1 = require("./AcSalesPersonField");
var AcSubSalesPersonsField = function (_a) {
    var salesPersons = _a.salesPersons, value = _a.value, fieldName = _a.fieldName, label = _a.label, handleDataChange = _a.handleDataChange;
    var addSubSalesPerson = function () {
        handleDataChange(fieldName, value.concat(['']));
    };
    var deleteSubSalesPerson = function (index) {
        var _cloned = value.slice();
        handleDataChange(fieldName, _cloned.filter(function (s, i) { return i !== index; }));
    };
    var renderFields = function () {
        if (value.length > 0) {
            return (react_1.default.createElement(react_1.default.Fragment, null, value.map(function (s, i) { return (react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-6" },
                    react_1.default.createElement(AcSalesPersonField_1.AcSalesPersonField, { key: "subSalesperson_" + s.userId, fieldName: fieldName, value: s, label: i === 0 ? label : undefined, onBlur: function (_fieldName, val) {
                            var _cloned = value.slice();
                            _cloned[i] = val !== null && val !== void 0 ? val : null;
                            handleDataChange(_fieldName, _cloned);
                        }, onChange: function (_fieldName, val) {
                            var _cloned = value.slice();
                            _cloned[i] = val !== null && val !== void 0 ? val : null;
                            handleDataChange(_fieldName, _cloned);
                        }, salesPersons: salesPersons })),
                value.length > 1 && i === value.length - 1 && (react_1.default.createElement("div", { className: "col-md-6 pl-0" },
                    react_1.default.createElement(ac_ui_1.AcButton, { className: "ml-2", height: 43, variant: "outline-apzlinkblue", onClick: function () { return deleteSubSalesPerson(i); } }, "\u524A\u9664"))))); })));
        }
        return (react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-6" },
                react_1.default.createElement("div", { className: "flex-grow-1", style: { minWidth: 0 } },
                    react_1.default.createElement("div", { className: "d-flex flex-row", style: { minWidth: 0 } },
                        react_1.default.createElement("div", { className: "flex-grow-1", style: { minWidth: 0 } },
                            react_1.default.createElement(AcSalesPersonField_1.AcSalesPersonField, { key: 'subSalesperson_0', fieldName: fieldName, value: '', label: label, onBlur: function (_fieldName, val) {
                                    handleDataChange(fieldName, [val]);
                                }, onChange: function (_fieldName, val) {
                                    handleDataChange(fieldName, [val]);
                                }, salesPersons: salesPersons })))))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderFields(),
        react_1.default.createElement(ac_ui_1.AcButton, { className: "p-3", variant: "outline-apzlinkblue", onClick: addSubSalesPerson },
            react_1.default.createElement("i", { className: "fas fa-plus fa-fw mr-1" }),
            "\u526F\u62C5\u5F53\u3092\u8FFD\u52A0")));
};
exports.AcSubSalesPersonsField = AcSubSalesPersonsField;
exports.AcSubSalesPersonsField.displayName = 'AcSubSalesPersonsField';
//# sourceMappingURL=AcSubSalesPersonsField.js.map